import { Actions } from 'vuex-smart-module';
import { RequestPagination } from '@/types';
import { AlfaApiLoanApplicationService } from '../services';
import AlfaApiLoanApplicationsState from './state';
import AlfaApiLoanApplicationsGetters from './getters';
import AlfaApiLoanApplicationsMutations from './mutations';

const service = new AlfaApiLoanApplicationService();

export default class AlfaApiLoanApplicationsActions extends Actions<
  AlfaApiLoanApplicationsState,
  AlfaApiLoanApplicationsGetters,
  AlfaApiLoanApplicationsMutations,
  // eslint-disable-next-line no-use-before-define
  AlfaApiLoanApplicationsActions
> {
  async get_loan_applications() {
    this.mutations.SET_ALFA_API_LOAN_APPLICATIONS_LOADING(true);

    try {
      const {
        sortBy = [],
        sortDesc = [],
        page = 1,
        itemsPerPage = 10,
      } = this.state.table_options;

      const {
        organizationIds,
        statusIds,
        orderIds,
        createdDateRange,
        orderDateRange,
      } = this.state.filters;

      const pagination: RequestPagination = {
        page,
        limit: itemsPerPage,
        sort: sortBy.length ? sortBy[0] : '',
        sort_type: sortDesc.length && sortDesc[0] ? 'desc' : 'asc',
      };

      const { data, meta } = await service.get(
        organizationIds,
        statusIds,
        orderIds,
        createdDateRange,
        orderDateRange,
        pagination,
      );

      this.mutations.SET_ALFA_API_LOAN_APPLICATIONS(data);

      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.per_page });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });

      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.last_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.per_page });
    } catch (error) {
      console.log(error);
    } finally {
      this.mutations.SET_ALFA_API_LOAN_APPLICATIONS_LOADING(false);
    }
  }
}
